import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UploadFilesComponent } from './upload-files.component';
import { UploadFilesViewComponent } from './components/upload-files-view/upload-files-view.component';
import { UploadFilesDetailsComponent } from './components/upload-files-details/upload-files-details.component';
const routes: Routes = [
  {
    path: '', component:UploadFilesComponent,children:[
       {
                path:'',component: UploadFilesDetailsComponent
              },
       {
        path:'views',component: UploadFilesViewComponent
       },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UploadFilesRoutingModule { }
